import React from 'react';
import useStripe from '../../Hooks/useStripe';
import Text from '../../../../Components/Base/Text/Text';
// @ts-ignore
import styles from './StripeConfigurationRequestMessage.module.scss';

interface Props {
	message: string;
}

const StripeConfigurationRequestMessage: React.FC<Props> = ({ message }) => {
	const { isStripeSetupRequested } = useStripe();

	if (isStripeSetupRequested) {
		return <Text tx={message} className={styles.wrapper} />;
	}

	return <></>;
};

export default StripeConfigurationRequestMessage;
